import React, { Component } from "react";
import "./App.css";
import { Switch, BrowserRouter, Route, Redirect } from "react-router-dom";
import { getUser } from "../../actions/users";
import {
  setRefreshedUser,
  loginSuccess,
  refreshToken,
  setUser,
} from "../../actions/authentication";
import { isEmpty } from "lodash";
import Login from "../../pages/Login";
import Checkout from "../../pages/Checkout";
import UserProfileForm from "../../pages/UserProfileForm";
import Snackbar from "@material-ui/core/Snackbar";
import { closeSnackBar } from "../../actions/snack-bar";
import { compose } from "recompose";
import { connect } from "react-redux";
import withWidth from "@material-ui/core/withWidth";
import ProtectedRoute from "../ProtectedRoute";
import FormDialog from "../FormDialog";
import PageNotFound from "../../pages/PageNotFound";
import Showings from "../../pages/Showings";
import ShowingsDetail from "../../pages/ShowingsDetail";
import LogPage from "../../pages/LogPage";
import Timer from "../../pages/Timer";
import MagicLink from "../../pages/MagicLink";
import ShowingsDone from "../../pages/ShowingsDone";
import ShowingComplete from "../../pages/ShowingComplete";
// import PanicSnackbar from '../PanicSnackbar'
import LandingPage from "../../pages/LandingPage";
import PanicModal from "../panicModal";
import EmailModal from "../emailModal";
import BuyerProfile from "../BuyerProfile";
import OrgLogin from "../Organisation/Login";
import OrgDashboard from "../Organisation/Dashboard";
import ShowingsList from "../Organisation/ShowingsList";
import ManageOrganisations from "../Admin/ManageOrganisations";
import ManageBuyers from "../Admin/ManageBuyers";
import CreatePassword from "../Organisation/Login/CreatePassword";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import FaceSnap from "../../pages/FaceSnap";
class App extends Component {
  constructor(props) {
    super(props);

    this.pubNub = null;

    this.setPubNubRef = (element) => {
      this.pubNub = element;
    };
  }
  componentDidMount() {
    if (
      this.props.authentication.token &&
      !isEmpty(this.props.authentication.authenticatedUser)
    ) {
      this.props
        .dispatch(getUser(this.props.authentication.authenticatedUser.id))
        .then((res) => {
          this.props.dispatch(loginSuccess(res));
          this.props.dispatch(setRefreshedUser());
        });
    }
  }
  doRefresh = () => {
    const deferred = new Promise((resolve, reject) => {
      this.props
        .dispatch(refreshToken())
        .then(() => {
          this.props
            .dispatch(getUser(this.props.authentication.authenticatedUser.id))
            .then((res) => {
              this.props.dispatch(setUser(res));
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((err) => {
          reject(err);
        });
    });
    return deferred;
  };

  render() {
    const snackBarOrigin = { vertical: "top", horizontal: "right" };
    return (
      <div>
        <BrowserRouter>
          <Switch>
            <Route exact path="/" component={LandingPage} />

            <Route exact path="/register" component={Login} />
            <Route exact path="/FaceSnap/register" component={FaceSnap} />
            <Route exact path="/organization/login" component={OrgLogin} />
            <Route
              exact
              path="/organization"
              render={() => <Redirect to="/organization/login" />}
            />

            <ProtectedRoute
              props={this.props}
              exact
              path="/admin/manage-organizations"
              component={ManageOrganisations}
            />

            <ProtectedRoute
              props={this.props}
              exact
              path="/admin/manage-buyers"
              component={ManageBuyers}
            />

            <ProtectedRoute
              props={this.props}
              exact
              path="/admin/manage-realtor"
              component={OrgDashboard}
            />

            <ProtectedRoute
              props={this.props}
              exact
              path="/admin/showings-list/:id"
              component={ShowingsList}
            />

            <ProtectedRoute
              props={this.props}
              exact
              path="/organization/showings-list/:id"
              component={ShowingsList}
            />

            <ProtectedRoute
              props={this.props}
              exact
              path="/organization/dashboard"
              component={OrgDashboard}
            />

            <Route
              props={this.props}
              exact
              path="/organization/create-password/:token"
              component={CreatePassword}
            />

            <ProtectedRoute
              props={this.props}
              exact
              path="/checkout"
              component={Checkout}
            />

            <ProtectedRoute
              exact
              props={this.props}
              path="/profile"
              component={UserProfileForm}
            />

            <ProtectedRoute
              exact
              props={this.props}
              path="/showings"
              component={Showings}
            />
            <ProtectedRoute
              exact
              props={this.props}
              path="/showings/start/:id"
              component={ShowingsDetail}
            />
            <ProtectedRoute
              exact
              props={this.props}
              path="/showings/done/:id"
              component={ShowingsDone}
            />
            <ProtectedRoute
              exact
              props={this.props}
              path="/showing/complete/:id"
              component={ShowingComplete}
            />

            <ProtectedRoute
              exact
              props={this.props}
              path="/showings/timer/:id"
              component={Timer}
            />
            <ProtectedRoute
              exact
              props={this.props}
              path="/e/:event_id"
              component={LogPage}
            />
            <ProtectedRoute
              exact
              props={this.props}
              path="/buyer-profile"
              component={BuyerProfile}
            />
            <Route path="/magic" component={MagicLink} />

            <Route path="*" component={PageNotFound} />
          </Switch>
        </BrowserRouter>
        <FormDialog
          full
          style={{
            padding: "0 70px",
          }}
        />
        <Snackbar
          anchorOrigin={snackBarOrigin}
          open={this.props.snackBar.open}
          onClose={() => this.props.dispatch(closeSnackBar())}
          className="Toast"
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          autoHideDuration={this.props.snackBar.autoHideDuration}
          message={<span id="message-id"> {this.props.snackBar.message} </span>}
          action={[
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              onClick={() => this.props.dispatch(closeSnackBar())}
            >
              <CloseIcon className="icon" />
            </IconButton>,
          ]}
        />
        {window.location.pathname !== "/register" ? (
          <>
            <PanicModal />
            <EmailModal />
          </>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authentication: state.authentication,
    snackBar: state.snackBar,
    messageDrawerVisible: state.messageDrawer.visible,
  };
};

export default compose(connect(mapStateToProps), withWidth())(App);
